import React, { useEffect, useState } from "react";
import {
  TextField,
  Autocomplete,
  CircularProgress,
  useTheme,
} from "@mui/material";
import { GET } from "../../api/ApiService";

const JudgeSearchDropdown = ({
  name,
  label,
  value,
  onChange,
  onBlur,
  error,
  touched,
  reset,
}) => {
  const [options, setOptions] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [loading, setLoading] = useState(false);
  const selectedValue =
    typeof value === "string" ? { label: value, id: value } : value || null;

  const theme = useTheme();

  useEffect(() => {
    if (reset) {
      setInputValue("");
      setOptions([]);
    }
  }, [reset]);

  useEffect(() => {
    if (selectedValue?.label) {
      setInputValue(selectedValue.label);
      setOptions((prevOptions) => {
        const exists = prevOptions.some(
          (option) =>
            option?.contactId === selectedValue?.contactId &&
            option?.label === selectedValue?.label,
        );
        return exists ? prevOptions : [selectedValue, ...prevOptions];
      });
    } else if (!selectedValue) {
      setInputValue("");
    }
  }, [selectedValue]);

  const handleInputChange = (event, value) => {
    setInputValue(value);
    if (value.length > 1) {
      setLoading(true);
      GET(`contact/fetchJudges?search=${value}`)
        .then((response) => {
          const dropdownData = response?.data?.map((item) => {
            return {
              label: item.Name,
              id: item.Name,
              contactId: item.ContactID,
              type: item.Type,
              visibility: item.Visibility,
            };
          });

          setOptions(dropdownData);
        })
        .catch((err) => {
          console.warn(err);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      setOptions([]);
    }
  };

  return (
    <div>
      <Autocomplete
        name={name}
        options={options}
        getOptionLabel={(option) => option?.label || ""}
        isOptionEqualToValue={(option, selectedValue) =>
          option?.contactId === selectedValue?.contactId &&
          option?.label === selectedValue?.label
        }
        onInputChange={handleInputChange}
        inputValue={inputValue}
        onChange={onChange}
        value={selectedValue}
        onBlur={onBlur}
        loading={loading}
        sx={{
          "& .MuiOutlinedInput-root": {
            padding: 0,
            paddingLeft: "9px",
            // Hover color using theme
            "&:hover fieldset": {
              borderColor: theme.palette.black.main, // Dynamic hover color
            },
            // Focused color using theme
            "&.Mui-focused fieldset": {
              borderColor: theme.palette.black.main, // Same color for focus
            },
          },
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            placeholder="Search Judge..."
            variant="outlined"
            error={touched && Boolean(error)}
            helperText={touched && error}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {loading ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </>
              ),
            }}
          />
        )}
        clearOnBlur={false}
      />
    </div>
  );
};

export default JudgeSearchDropdown;
